export default __webpack_public_path__ + "static/media/bakery_cat_disabled.57e9821c.png";